import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_b_skeleton = _resolveComponent("b-skeleton");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_b_skeleton, {
    animated: true,
    width: "30%"
  }), _createVNode(_component_b_skeleton, {
    animated: true,
    width: "70%"
  }), _createVNode(_component_b_skeleton, {
    animated: true,
    width: "20%"
  }), _createVNode(_component_b_skeleton, {
    animated: true,
    width: "60%"
  }), _createVNode(_component_b_skeleton, {
    animated: true,
    width: "40%"
  }), _createVNode(_component_b_skeleton, {
    animated: true,
    width: "50%"
  })]);
}